import { WorkPackage } from '../types';

export const WP0_CODE = 'WP0';

export const WP0_TIMESHEET_LOCK_MESSAGE =
  'WP0 cannot be removed because it has timesheet entries.';

export function isWp0(code?: string | null): boolean {
  return (code || '').trim().toUpperCase() === WP0_CODE;
}

export function hasWp0(workPackages: WorkPackage[]): boolean {
  return workPackages.some((wp) => isWp0(wp.code));
}

export function isWp0LockedByTimesheet(workPackages: WorkPackage[]): boolean {
  return workPackages.some((wp) => isWp0(wp.code) && Boolean(wp.has_timesheet_entries));
}

export function withWp0(workPackages: WorkPackage[], include: boolean): WorkPackage[] {
  if (!include) {
    return workPackages.filter((wp) => !isWp0(wp.code));
  }
  if (hasWp0(workPackages)) {
    return workPackages;
  }
  return [
    { id: 0, code: WP0_CODE, title: '', workUnits: [] },
    ...workPackages,
  ];
}
